var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtnDarkRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.425,
    width: 31.25,
    height: 31.425,
    rx: 15.625,
    transform: "rotate(90 31.425 0)",
    fill: "#B83739"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.324 10.0449L10.1008 21.2056",
    stroke: "#FFFEFA",
    strokeWidth: 3.34821,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9489 20.8346L10.4739 10.418",
    stroke: "#FFFEFA",
    strokeWidth: 3.34821,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtnDarkRed);
export default __webpack_public_path__ + "static/media/close_btn_dark-red.0ecdbbef48a281acc4e1be46aaf535e4.svg";
export { ForwardRef as ReactComponent };